import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginResponse } from '../models/auth-state.model';

@Injectable()
export class LoginRepository {
  constructor(private http: HttpClient) {}

  /**
   * Logs a user into SCS
   *
   * @param username User name
   * @param password Password
   * @returns User login response stream
   */

  login(username: string, password: string): Observable<HttpResponse<LoginResponse>> {
    const url = environment.auth.login;
    return this.http.post<LoginResponse>(url, { password, username }, { observe: 'response' }).pipe(
      map((res) => res),
      catchError(this.handleError),
    );
  }

  logout(token: string): Observable<HttpResponse<void>> {
    const headers = new HttpHeaders().set('X-Auth-Token', token);
    const url = environment.auth.logout;
    return this.http.post<void>(url, null, { headers, observe: 'response' }).pipe(
      map((res) => res),
      catchError(this.handleError),
    );
  }

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }
}
